import { render, staticRenderFns } from "./ViewPostMedia.vue?vue&type=template&id=7c35c9a8&"
import script from "./ViewPostMedia.vue?vue&type=script&lang=js&"
export * from "./ViewPostMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports